import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

/**
 * ContextMenu - floating menu at cursor position.
 * @param {number} x - left position
 * @param {number} y - top position
 * @param {Array} items - [{ label, onClick, separator?, dimmed? }]
 * @param {Function} onClose - dismiss callback
 */
export default function ContextMenu({ x, y, items, onClose }) {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    // Adjust position to stay within viewport
    const adjustedX = Math.min(x, window.innerWidth - 200);
    const adjustedY = Math.min(y, window.innerHeight - (items.length * 32 + 16));

    return ReactDOM.createPortal(
        <div
            ref={menuRef}
            style={{
                position: 'fixed',
                left: adjustedX,
                top: adjustedY,
                zIndex: 9999,
                background: '#fff',
                border: '1px solid #DADCE0',
                borderRadius: 6,
                boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                minWidth: 180,
                padding: '4px 0',
            }}
        >
            {items.map((item, i) => {
                if (item.separator) {
                    return <div key={'sep-' + i} style={{ height: 1, background: '#E8EAED', margin: '4px 0' }} />;
                }
                return (
                    <button
                        key={item.label + i}
                        onClick={() => { item.onClick(); onClose(); }}
                        disabled={item.dimmed}
                        style={{
                            display: 'block',
                            width: '100%',
                            padding: '6px 16px',
                            border: 'none',
                            background: 'transparent',
                            textAlign: 'left',
                            fontSize: 13,
                            color: item.dimmed ? '#BDC1C6' : '#3C4043',
                            cursor: item.dimmed ? 'default' : 'pointer',
                            opacity: item.dimmed ? 0.5 : 1,
                        }}
                        onMouseEnter={(e) => { if (!item.dimmed) e.currentTarget.style.background = 'var(--color-bg-base)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                    >
                        {item.label}
                    </button>
                );
            })}
        </div>,
        document.body
    );
}
